import ReactModal from "react-modal";

// Global flag to track if ReactModal has been initialized
let isReactModalInitialized = false;

// Modal manager to track open modals
let openModalCount = 0;

/**
 * Initialize ReactModal with the app element
 * This function ensures ReactModal is only initialized once
 */
export const initializeReactModal = () => {
  if (!isReactModalInitialized && process.env.NODE_ENV !== "test") {
    try {
      // Check if the root element exists
      const rootElement = document.getElementById("root");
      if (!rootElement) {
        console.warn(
          "Root element not found, ReactModal initialization delayed"
        );
        return;
      }

      ReactModal.setAppElement("#root");
      isReactModalInitialized = true;
    } catch (error) {
      // If ReactModal is already initialized, that's fine
      if (error.message && error.message.includes("already been set")) {
        isReactModalInitialized = true;
      } else {
        console.warn("ReactModal initialization failed:", error);
      }
    }
  }
};

/**
 * Register a modal as open
 */
export const registerModalOpen = () => {
  openModalCount++;
};

/**
 * Register a modal as closed
 */
export const registerModalClose = () => {
  openModalCount = Math.max(0, openModalCount - 1);
};

/**
 * Get the number of open modals
 */
export const getOpenModalCount = () => {
  return openModalCount;
};

/**
 * Reset the initialization flag (useful for testing)
 */
export const resetReactModalInitialization = () => {
  isReactModalInitialized = false;
  openModalCount = 0;
};

/**
 * Check if ReactModal is initialized
 */
export const getReactModalInitializationStatus = () => {
  return isReactModalInitialized;
};
